import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const PosterTraining = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, posterTraining: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false);
	}
	
	const steps = [
		{
			target: '.posterTrainingFirstStep',
			title: "First Training Poster",
			content: 'Create your first training poster.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.posterTrainingSecondStep',
			title: "Choose Traning Template",
			content: 'Select this training template.',
			disableBeacon: true,
			placement: "bottom",
			modalTriggers: 'posterTraining'
		},
		{
			target: '.posterTrainingThirdStep',
			title: "Customize Training Template",
			content: 'Customize selected template.',
			disableBeacon: true,
			placement: "bottom",
			modalTriggers: 'posterTrainingCustomize'
		},
		{
			target: '.posterTrainingFourthStep',
			title: "Edit Content",
			content: "Edit page poster here.",
			disableBeacon: true,
			placement: "bottom",
			modalTriggers: 'posterTrainingPreview'
		},
		{
			target: '.posterTrainingFifthStep',
			title: "Style Page",
			content: "Adjust poster styles.",
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.posterTrainingSixthStep',
			title: "Poster Details",
			content: "View main poster details.'",
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.posterTrainingSeventhStep',
			title: "Save Trainig Poster",
			content: 'Save your training poster.',
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.posterTrainingEightStep',
			title: "Post Training Poster",
			content: 'Post you training poster.',
			disableBeacon: true,
			placement: "bottom"
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.posterTrainingFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, []);

	return (
		firstStepReady && 
            <JoyrideWrapper 
                run={Boolean(walkthrough.data.posterTraining)} 
                steps={steps} 
                setter={endTour} 
                end={end}
                p_name="posterTraining" 
                featureName="campaign"
            />
	);
}
